import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountUser } from '../../../../models/account-user.model';
import { CaseAccess } from '../../../../models/ui/case-access.model';
import { CaseAccessManager } from '../../../../managers/case-access.manager';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'lex-manage-case-edit',
    templateUrl: './manage-case-edit.component.html',
    styleUrls: ['./manage-case-edit.component.scss'],
    standalone: false
})
export class ManageCaseEditComponent implements OnChanges {
	@Input() accountId: string;
	@Input() case: CaseAccess;
	@Input() currentUsers: AccountUser[] = [];
	@Output() clearSelectionChange = new EventEmitter();

	public userIds: string[] = [];
	public users$: Observable<AccountUser[]>;

	constructor(
		private caseAccessManager: CaseAccessManager,
		private snackBar: MatSnackBar) {
		this.users$ = this.caseAccessManager.activeUserCollection$.pipe();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.accountId && this.accountId) {
			this.caseAccessManager.getActiveUsers(this.accountId);
		}
		if (changes.currentUsers && this.currentUsers) {
			this.userIds = this.currentUsers.map(x => x.userId);
		}
	}

	public selectAllAccess(users: AccountUser[]): void {
		this.userIds = users.map(x => x.userId);
	}

	public removeAllAccess(): void {
		this.userIds = [];
	}

	public updateCaseAccess(): void {
		this.caseAccessManager.updateCaseUsersAccesses(this.case, this.userIds).subscribe(() => {
			this.clearSelectionChange.emit(true);
		}, err => {
			this.clearSelectionChange.emit(false);
			this.snackBar.open('Update user encountered error: ' + err.error.message, 'X');
		});
	}

	public cancel(): void {
		this.clearSelectionChange.emit(false);
	}

}
